var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-entry"},[(_vm.ready && _vm.activeHomeComponent)?_c(_vm.activeHomeComponent,{tag:"component"}):_c('div',{staticClass:"homepage-entry__loading"},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }